import { Grid } from "@mui/material";
import { PlatformsEnum } from "src/constants/platforms";
import DashboardCards from "src/sections/dashboards/charts/dashboard-cards";
import { DashboardType } from "src/types/types";
import DashboardStatisticsGroupContainer from "../../charts/dashboard-statistics-group-container/dashboard-statistics-group-container";
import { STATISTICS } from "../../charts/dashboard-statistics-group-container/statistics";
import SentimentChart from "../../charts/sentiment-chart/sentiment-chart";
import DashboardViewLayout from "../../../../layouts/dashboard/view/dashboard-view-layout";
import useForbesDashboardView from "./use-forbes-dashboard-view";

const ForbesDashboardView = ({ type }: { type: DashboardType }) => {
  const { platformData, isDataLoading, error } = useForbesDashboardView({ type });

  return (
    <DashboardViewLayout
      isLoading={isDataLoading}
      type={type}
      platform={PlatformsEnum.FORBES}
      pageTitle="Adam Radar | Forbes dashboard"
      error={error}
    >
      <Grid item xs={12}>
        {platformData?.analysis.cards?.length && (
          <DashboardCards cards={platformData?.analysis.cards} />
        )}
      </Grid>
      {platformData?.analysis.pieChart && (
        <Grid item xs={12}>
          <SentimentChart data={platformData?.analysis.pieChart} />
        </Grid>
      )}
      {platformData && (
        <Grid item xs={12}>
          <DashboardStatisticsGroupContainer statistics={STATISTICS(platformData)} />
        </Grid>
      )}
    </DashboardViewLayout>
  );
};

export default ForbesDashboardView;
